import React from 'react';

// Display heading with wide letter spacing to mimic the original
export default function SpacedHeading({ children, className = '' }) {
  const text = String(children);
  return (
    <h2 className={`font-display leading-[0.95] uppercase ${className}`}>
      {text.split(' ').map((word, i) => (
        <span key={i} className="inline-block mr-[0.45em] last:mr-0">
          {word.split('').map((c, j) => (
            <span key={j} className="inline-block mx-[0.06em]">
              {c}
            </span>
          ))}
        </span>
      ))}
    </h2>
  );
}
